import { DEFAULT_LOCALE, LOCALE_CATALOG, SUPPORTED_LOCALES, type SupportedLocale } from './types'

/**
 * Collation base is fixed to `'en'` (never the active UI locale) so display order
 * is identical on every surface and for every user.
 */
const collator = new Intl.Collator('en', { sensitivity: 'base' })

/**
 * Pure English-first + endonym sort.
 * {@link getOrderedLocales}.
 */
export function orderLocalesByEndonym(
  locales: readonly string[],
  endonyms: Readonly<Record<string, string>>,
  pinnedFirst: string = DEFAULT_LOCALE
): string[] {
  const rest = locales
    .filter((locale) => locale !== pinnedFirst)
    .sort((a, b) => collator.compare(endonyms[a] ?? a, endonyms[b] ?? b))
  return locales.includes(pinnedFirst) ? [pinnedFirst, ...rest] : rest
}

/** Display order for Family Portal language selectors. */
export function getOrderedLocales(): SupportedLocale[] {
  const endonyms = Object.fromEntries(SUPPORTED_LOCALES.map((tag) => [tag, LOCALE_CATALOG[tag].endonym])) as Record<
    string,
    string
  >
  return orderLocalesByEndonym(SUPPORTED_LOCALES, endonyms) as SupportedLocale[]
}
